import * as React from 'react';
import { ArticleHeading1, ArticleParagraph1 } from '@cian/ui-kit';
import * as styles from './styles.css';

interface IPikPlusLayoutProps {
  title: string;
  description: string;
  card: React.ReactNode;
  link: React.ReactNode;
  carousel: React.ReactNode;
}

export function PikPlusLayout({ title, description, link, card, carousel }: IPikPlusLayoutProps) {
  return (
    <div className={styles['container']} data-testid="pik_plus_layout">
      <div className={styles['header']}>
        <div className={styles['title']}>
          <ArticleHeading1 data-testid="pik_plus_title" color={'white_100'}>
            {title}
          </ArticleHeading1>
        </div>
        <div className={styles['description']}>
          <ArticleParagraph1 data-testid="pik_plus_description" color={'white_100'}>
            {description}
          </ArticleParagraph1>
        </div>
      </div>
      <div className={styles['content']}>
        {card}
        <div className={styles['carousel']}>{carousel}</div>
      </div>
      <div className={styles['footer']}>{link}</div>
    </div>
  );
}
